// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"index_itemContainer__2Vlqw","elementMenu":"index_elementMenu__39FVt"};